import { styled, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import LinearProgress from '@mui/material/LinearProgress';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const PrescriptionRenewalCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.neutrals.beige2,
  borderRadius: 8,
  padding: theme.spacing(2.5),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
  textAlign: 'center',
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3)
}));

export const PrescriptionRenewalTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1R,
  color: theme.palette.neutrals.lead,
  textAlign: 'left',
  lineHeight: 1.5
}));

export const PrescriptionRenewalInfoRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1.5),
  alignItems: 'flex-start',
  width: '100%'
}));

export const PrescriptionRenewalInfoIcon = styled(InfoOutlinedIcon)(({ theme }) => ({
  color: theme.palette.brand.mediumGreen,
  fontSize: 20,
  flexShrink: 0
}));

export const PrescriptionRenewalInfoText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body7,
  color: theme.palette.brand.darkGreen,
  textAlign: 'left',
  lineHeight: 1.4
}));

export const PrescriptionRenewalRequestButton = styled(Button)(({ theme }) => ({
  '&.Mui-disabled': {
    color: alpha(theme.palette.brand.darkGreen as string, 0.4)
  }
}));

export const PrescriptionRenewalLoading = styled(LinearProgress)(({ theme }) => ({
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
  height: 6,
  borderRadius: 4,
  backgroundColor: theme.palette.neutrals.beige3,
  '& .MuiLinearProgress-bar': {
    backgroundColor: theme.palette.brand.darkGreen
  }
}));
